import React from "react";
import SocialNav from "./SocialNav";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <p className="site-footer-message">
          Simplifying Life Through Technology
        </p>
        <SocialNav />
        <div className="site-footer-meta">
          &copy; {new Date().getFullYear()} MileSoft. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
